(() => {
  const instances = new WeakMap();
  const popularNames = ['Techniker Krankenkasse', 'BARMER', 'DAK-Gesundheit', 'AOK Bayern', 'AOK Baden-Württemberg', 'AOK PLUS', 'IKK classic', 'hkk', 'Knappschaft', 'SBK'];
  const normalize = value => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
  window.PrevuraInsurerPicker = (root, select, { signal } = {}) => {
    if (!root || !select) return null;
    if (instances.has(root)) return instances.get(root);
    const trigger = root.querySelector('[data-insurer-trigger]');
    const label = root.querySelector('[data-insurer-label]');
    const menu = root.querySelector('[data-insurer-menu]');
    if (!trigger || !label || !menu) return null;
    const events = signal ? { signal } : undefined;
    const source = [...select.options].filter(option => option.value);
    const byValue = new Map(source.map(option => [option.value, option]));
    const popular = popularNames.map(name => byValue.get(name)).filter(Boolean);
    const popularSet = new Set(popular.map(option => option.value));
    const options = [];
    const groups = [];
    menu.replaceChildren();
    menu.setAttribute('role', 'dialog');
    trigger.setAttribute('aria-haspopup', 'dialog');
    const searchWrap = document.createElement('div');
    searchWrap.className = 'pv-insurer-picker__search-wrap';
    const searchInput = document.createElement('input');
    searchInput.type = 'search';
    searchInput.className = 'pv-insurer-picker__search';
    searchInput.placeholder = 'Krankenkasse suchen';
    searchInput.setAttribute('aria-label', 'Krankenkasse suchen');
    searchInput.setAttribute('autocomplete', 'off');
    searchInput.setAttribute('autocapitalize', 'none');
    searchInput.spellcheck = false;
    searchInput.dataset.insurerSearch = '';
    searchWrap.append(searchInput);
    const list = document.createElement('div');
    list.className = 'pv-insurer-picker__options';
    list.id = `${menu.id}-options`;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Krankenkassen');
    searchInput.setAttribute('aria-controls', list.id);
    const status = document.createElement('p');
    status.className = 'pv-insurer-picker__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    menu.append(searchWrap, list, status);
    const visibleOptions = () => options.filter(option => !option.hidden);
    const sync = () => {
      label.textContent = select.selectedOptions[0]?.textContent || select.options[0]?.textContent || '';
      options.forEach(option => {
        const selected = option.dataset.value === select.value;
        option.classList.toggle('is-active', selected);
        option.setAttribute('aria-selected', String(selected));
      });
    };
    const filter = () => {
      const words = normalize(searchInput.value).trim().split(/\s+/).filter(Boolean);
      options.forEach(option => {
        option.hidden = !words.every(word => normalize(option.textContent + (option.textContent.includes('Techniker Krankenkasse') ? ' TK' : '')).includes(word));
        option.tabIndex = -1;
      });
      groups.forEach(group => { group.heading.hidden = group.items.every(option => option.hidden); });
      const shown = visibleOptions();
      if (shown.length) shown[0].tabIndex = 0;
      status.hidden = words.length === 0;
      status.textContent = shown.length ? `${shown.length} ${shown.length === 1 ? 'Krankenkasse gefunden' : 'Krankenkassen gefunden'}` : 'Keine Krankenkasse gefunden. Versuche einen anderen Namen.';
      list.scrollTop = 0;
    };
    const close = (restoreFocus = false) => {
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
      options.forEach(option => { option.tabIndex = -1; });
      if (restoreFocus) trigger.focus({ preventScroll: true });
    };
    const focusOption = index => {
      const shown = visibleOptions();
      if (!shown.length) return;
      const option = shown[Math.max(0, Math.min(index, shown.length - 1))];
      options.forEach(item => { item.tabIndex = item === option ? 0 : -1; });
      option.focus({ preventScroll: true });
      const top = option.offsetTop - list.offsetTop;
      if (top < list.scrollTop) list.scrollTop = top;
      else if (top + option.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = top + option.offsetHeight - list.clientHeight;
    };
    const open = (focusSearch = true) => {
      searchInput.value = '';
      filter();
      trigger.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      if (focusSearch) searchInput.focus({ preventScroll: true });
      else focusOption(Math.max(0, visibleOptions().findIndex(option => option.dataset.value === select.value)));
    };
    const appendGroup = (title, items) => {
      if (!items.length) return;
      const heading = document.createElement('div');
      heading.className = 'pv-insurer-picker__group';
      heading.textContent = title;
      heading.setAttribute('role', 'presentation');
      const group = { heading, items: [] };
      groups.push(group);
      list.append(heading);
      items.forEach(item => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'pv-insurer-picker__option';
        option.setAttribute('role', 'option');
        option.tabIndex = -1;
        option.dataset.value = item.value;
        option.textContent = item.textContent;
        option.addEventListener('click', () => {
          select.value = item.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
          close(true);
        }, events);
        options.push(option);
        group.items.push(option);
        list.append(option);
      });
    };
    appendGroup('Beliebt', popular);
    appendGroup('Alle Krankenkassen', source.filter(option => !popularSet.has(option.value)));
    searchInput.addEventListener('input', filter, events);
    trigger.addEventListener('click', event => {
      if (!menu.hidden) { close(true); return; }
      const touchLike = event.pointerType === 'touch' || event.pointerType === 'pen' || matchMedia('(max-width: 749px), (pointer: coarse)').matches;
      open(!touchLike);
    }, events);
    root.addEventListener('keydown', event => {
      if (event.isComposing) return;
      if (event.key === 'Escape' && !menu.hidden) {
        event.preventDefault(); event.stopPropagation(); close(true); return;
      }
      const current = visibleOptions().indexOf(document.activeElement);
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (event.target !== trigger && event.target !== searchInput && current < 0) return;
        event.preventDefault();
        if (menu.hidden) { open(); return; }
        if (event.target === searchInput) focusOption(event.key === 'ArrowUp' ? visibleOptions().length - 1 : 0);
        else if (event.key === 'ArrowUp' && current <= 0) searchInput.focus({ preventScroll: true });
        else focusOption(current + (event.key === 'ArrowDown' ? 1 : -1));
      } else if (current >= 0 && (event.key === 'Home' || event.key === 'End')) {
        event.preventDefault(); focusOption(event.key === 'Home' ? 0 : visibleOptions().length - 1);
      } else if (event.target === searchInput && event.key === 'Enter') {
        event.preventDefault();
        if (visibleOptions().length === 1) visibleOptions()[0].click();
        else focusOption(0);
      }
    }, events);
    root.addEventListener('focusout', event => {
      if (event.relatedTarget) { if (!root.contains(event.relatedTarget)) close(); return; }
      setTimeout(() => { if (!root.contains(document.activeElement)) close(); }, 0);
    }, events);
    document.addEventListener('click', event => { if (!event.composedPath().includes(root)) close(); }, events);
    select.addEventListener('change', sync, events);
    sync(); select.hidden = true; trigger.hidden = false; root.hidden = false;
    root.classList.add('is-enhanced');
    const result = { close, sync, element: root };
    instances.set(root, result);
    signal?.addEventListener('abort', () => {
      close(); instances.delete(root); root.classList.remove('is-enhanced'); select.hidden = false; trigger.hidden = true;
    }, { once: true });
    return result;
  };
})();
